import { IconsEnum } from '@modules/husleie-framework/src/enums/Icons.enum';
import { BankAccountEnum } from '@modules/husleie-framework/src/types/BankAccount.entity';
import { PaymentMethodEnum } from '@modules/husleie-framework/src/types/Payment.entity';
import { UpsellStatusEnum } from '@modules/husleie-framework/src/types/Upsell.entity';
import UpsellElectricityState from '@modules/store/upsell/types/UpsellElectricityState.entity';

export const state: UpsellElectricityState = {
  providerData: {
    providerName: null,
    kwhPrice: null,
    monthlyPrice: null,
    yearlyPrice: null,
    savings: null,
    tariff: {
      id: null,
      externId: null,
      basePrice: null,
      date: null,
      previousVolume: null,
      priceGuarantee: null,
      workPrice: null,
      bonus1th: null,
      bonus2nd: null,
    },
  },
  upsell: {
    status: UpsellStatusEnum.PRISTINE,
    partner: {
      name: '',
      component: '',
      images: {},
      benefits: [{}],
    },
    buttons: {
      value: UpsellStatusEnum.PRISTINE,
      options: [
        {
          name: 'UpsellAgree',
          value: UpsellStatusEnum.INTERESTED,
          icon: IconsEnum.HAPPY_FACE,
          term: 'upsell.electricity.btn.order',
        },
        {
          name: 'UpsellDecline',
          value: UpsellStatusEnum.DECLINED,
          icon: IconsEnum.THUMB_DOWN,
          term: 'upsell.electricity.btn.decline',
        },
      ],
    },
    customer: {
      payment: {
        method: PaymentMethodEnum.SEPA,
        bankAccount: {
          type: BankAccountEnum.IBAN,
          firstName: null,
          lastName: null,
          address: {
            street: null,
            additionalAddress: null,
            postalCode: null,
            postalArea: null,
            country: {
              code: null,
            },
          },
          number: null,
          additionalNumber: null,
          transferReference: null,
        },
      },
    },
    tariff: {
      basePrice: null,
      date: null,
      id: null,
      previousVolume: null,
      priceGuarantee: null,
      workPrice: null,
    },
  },
};
